import { Link } from "react-router-dom";
import { Logo } from "@/components/logo";
import { ArrowUpRight } from "@/components/icons";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="footer-main">
          <div className="footer-intro">
            <Logo inverse />
            <p>A clearer way to find current jobs across India.</p>
          </div>
          <div className="footer-cta">
            <p>Ready for what’s next?</p>
            <Link to="/jobs">Find your next role <ArrowUpRight /></Link>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-links">
            <Link to="/jobs">Jobs</Link>
            <Link to="/about">About</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/contact">Contact</Link>
            <a href="/sitemap">Sitemap</a>
          </div>
          <p>© {new Date().getFullYear()} Chuno</p>
        </div>
      </div>
    </footer>
  );
}
